import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { Calendar2ComponentDef } from '@df/ui/form/calendar/calendar2.component.def';
@Component({
    standalone: false,
    selector: 'icms-calendar',
    templateUrl: 'icms-calendar.html',
    styleUrls: ['icms-calendar.scss']
})
export class ICmsCalendarComponent extends Calendar2ComponentDef implements OnInit, OnDestroy {
    /**
     * If triangle should be printed
     */
    @HostBinding('class._triangle')
    @Input()
    triangle: boolean = false;
}
